import { BASE_PATHS, SEARCH_PATHS } from '@belong/common';
import { Button, Image, Link, Text } from '@belong/ui';
import type { PickedRegion } from 'src/store/region';

export const DEFAULT_COVER_IMAGE = 'ho_landing_header_2x.jpg';

// A lookup by region id, which is why the reads carry a fallback: not every
// region has a cover image here.
export const REGION_ID_TO_COVER_IMAGE_MAP: Record<number, string | undefined> =
  {
    1: 'ho_landing_header_bay-area.jpg',
    2: 'ho_landing_header_los-angeles.jpg',
    3: 'ho_landing_header_orange-county.jpg',
    4: 'ho_landing_header_san-diego.jpg',
    5: 'ho_landing_header_seattle.jpg',
  };

// phone numbers used in the sticky footer
const regionIdToHOLandingPhone = [
  '(833) 313-2564',
  '(650) 334-1226',
  '(310) 362-2092',
  '(714) 276-8396',
  '(858) 299-7902',
  '(206) 558-8221',
  '(786) 980-9880',
] as const;

export const NAVBAR_ACTIONS = {
  SEE_QUALIFY: () => (
    <Link
      href="/homeowner/onboard/property-address"
      variant="solid"
      className="h-xl"
      size="small"
    >
      <span className="text-p1 leading-p1">Get Started</span>
    </Link>
  ),
  ASK_A_QUESTION: () => (
    <Link
      href={`${BASE_PATHS.HOMEOWNER}?${SEARCH_PATHS.ASK_A_QUESTION}`}
      variant="text"
      buttonType="secondary"
      size="auto"
      shallow
    >
      <span className="text-p1 leading-p1">Ask a Question</span>
    </Link>
  ),
  PRICING: (handleClick: () => void) => (
    <Button
      variant="text"
      buttonType="secondary"
      size="auto"
      onClick={handleClick}
    >
      <span className="text-p1 leading-p1">Pricing</span>
    </Button>
  ),
  REGION_PHONE: (region: PickedRegion) => {
    const phone =
      region.information?.contactInformation?.phone ||
      regionIdToHOLandingPhone[0];

    return (
      <Link href={`tel:+1${phone.split(' ').join('')}`} variant="text">
        <div className="flex items-center">
          <div className="mr-2xs h-lg w-sm flex-none">
            <Image src="/homeowner-lp/icon_phone_color.svg" alt="" />
          </div>
          <div className="pt-2xs">{phone}</div>
        </div>
      </Link>
    );
  },
  GET_HELP: () => (
    <Link
      href="https://belongx.zendesk.com/hc/en-us"
      variant="text"
      buttonType="secondary"
      size="auto"
      shallow
    >
      <span className="text-p1 leading-p1">GET HELP</span>
    </Link>
  ),
  DOWNLOAD_APP: (handleClick: () => void) => (
    <Button
      variant="text"
      buttonType="secondary"
      size="auto"
      onClick={handleClick}
    >
      <span className="text-p1 leading-p1">DOWNLOAD</span>
    </Button>
  ),
};

export const TAX_TEXT = (
  <Text variant="p1">
    Plus, all maintenance expenses, management and placement fees are{' '}
    <Text as="span" variant="p1" fontWeight="semibold">
      {'tax\u00a0deductible.'}
    </Text>
  </Text>
);
